module.exports = __webpack_public_path__ + "img/dipingIcon.3d8cedf3.png";